import { FatcaExemptBeneficialOwner } from "further-types/lp/investor-tax-details";

export const fatcaExemptBeneficialOwnerLabels: Record<FatcaExemptBeneficialOwner, string> = {
  [FatcaExemptBeneficialOwner.BroadParticipationRetirementFund]: 'Broad participation retirement fund',
  [FatcaExemptBeneficialOwner.ForeignCentralBankOfIssue]: 'Foreign central bank of issue',
  [FatcaExemptBeneficialOwner.ForeignGovernment]: 'Foreign government',
  [FatcaExemptBeneficialOwner.GovernmentalRetirementFund]: 'Governmental retirement fund',
  [FatcaExemptBeneficialOwner.InternationalOrganisation]: 'International organisation',
  [FatcaExemptBeneficialOwner.NarrowParticipationRetirementFund]: 'Narrow participation retirement fund',
  [FatcaExemptBeneficialOwner.TreatyQualifiedRetirementFund]: 'Treaty qualified retirement fund',
};

export const fatcaExemptBeneficialOwnerOptions = Object.values(FatcaExemptBeneficialOwner).map(value => ({
  value,
  label: fatcaExemptBeneficialOwnerLabels[value]
}));
